"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7173],{

/***/ 87173:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ templates_anchor_menu; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./components/atoms/container/index.ts + 1 modules
var container = __webpack_require__(82112);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(77215);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(46572);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/common-tags/es/index.js + 40 modules
var es = __webpack_require__(62123);
// EXTERNAL MODULE: ./components/atoms/link/index.ts + 1 modules
var atoms_link = __webpack_require__(27594);
;// CONCATENATED MODULE: ./components/atoms/anchor-menu/AnchorMenu.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n              flex-shrink-0 border-b-[2px] border-primary-200 p-5 pb-4\n              ",
        "\n              ",
        " cursor-pointer text-[18px] "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var VARIANT_MAPS = {
    primary: " text-primary-400 scrollbar-transparente hover:scrollbar-primary",
    secondary: " text-primary-400 scrollbar-transparente hover:scrollbar-secondary",
    alternative: "bg-white scrollbar-transparente hover:scrollbar-secondary"
};
/**
 * AnchorMenu
 */ var AnchorMenu = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, element = param.element, variant = param.variant;
    var ref = (0,react.useState)(""), active = ref[0], setActive = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat(VARIANT_MAPS[variant], " flex flex-row overflow-auto ").concat(className),
        children: element.map(function(child, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: child.link,
                passHref: true,
                prefetch: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_link/* default */.Z, {
                    className: (0,es/* oneLine */.f9)(_templateObject(), variant === "alternative" ? "!text-black" : "", active === child.link ? "border-b-[2px] border-primary-600 font-bold" : "text-secondary font-medium !text-primary-300"),
                    variant: variant,
                    onClick: function() {
                        return setActive(child.link);
                    },
                    children: child.label
                })
            }, index);
        })
    });
};
AnchorMenu.displayName = "AnchorMenu";

;// CONCATENATED MODULE: ./components/atoms/anchor-menu/index.ts

/* harmony default export */ var anchor_menu = (AnchorMenu);

;// CONCATENATED MODULE: ./components/templates/anchor-menu/AnchorMenu.tsx


var AnchorMenu_VARIANT_MAPS = {
    primary: " text-primary-400 ",
    secondary: " text-primary-400",
    alternative: "bg-white "
};
/**
 * AnchorMenu
 */ var AnchorMenu_AnchorMenu = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, backgroundColorBottom = param.backgroundColorBottom, backgroundColorBottomMobile = param.backgroundColorBottomMobile, backgroundColorTop = param.backgroundColorTop, backgroundColorTopMobile = param.backgroundColorTopMobile, element = param.element, variant = param.variant, index = param.index, hasCutLevel = param.hasCutLevel;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
        index: index,
        backgroundColorBottom: backgroundColorBottom,
        backgroundColorTopMobile: backgroundColorTopMobile,
        backgroundColorTop: backgroundColorTop,
        backgroundColorBottomMobile: backgroundColorBottomMobile,
        hasCutLevel: hasCutLevel,
        overflows: true,
        className: " !py-1  ".concat(AnchorMenu_VARIANT_MAPS[variant], " ").concat(className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(anchor_menu, {
            element: element,
            variant: variant
        })
    });
};
AnchorMenu_AnchorMenu.displayName = "AnchorMenu";

;// CONCATENATED MODULE: ./components/templates/anchor-menu/index.ts

/* harmony default export */ var templates_anchor_menu = (AnchorMenu_AnchorMenu);


/***/ })

}]);